import { render } from "./NewModal.vue?vue&type=template&id=33794821"
import script from "./NewModal.vue?vue&type=script&lang=js"
export * from "./NewModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__